import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog/typings/dialog-ref';
import {ComponentType} from '@angular/cdk/portal';

@Injectable()
export class DialogService {

    constructor(private dialog: MatDialog) {
    }

    public showDialog<T, D = any>(componentRef: ComponentType<T>,
                                  data: object = {},
                                  width: Number = 400,
                                  height: Number | string = 'auto'): MatDialogRef<T> {
        // this.dialog.open

        return this.dialog.open(componentRef, {
            'width': `${width}px`,
            'height': typeof height === 'string' ? height : `${height}px`,
            'data': data
        });
    }
}



// WEBPACK FOOTER //
// /app/src/services/dialog.service.ts